<template>
    <CollapsibleWidget>
        <template #name>Master Template Resize</template>

        <Checkbox v-model="hideResized">Hide resized templates</Checkbox>
    </CollapsibleWidget>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

import { deepClone } from "@/utils";

import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import { FilterType, MasterTemplateLibraryAction } from "@/store/modules/masterTemplateLibrary";

export default defineComponent({
    name: "MasterTemplateResizedFilter",
    components: { CollapsibleWidget },

    props: {
        campaignMasterTemplateIds: {
            type: Array as PropType<string[]>,
            default() {
                return [];
            }
        }
    },

    computed: {
        filterValues() {
            return this.$store.state.masterTemplateLibrary.filters.filter(filter => filter.type === FilterType.Resized);
        },

        hideResized: {
            get() {
                if (this.filterValues.length) {
                    const filterValuesCopy = deepClone(this.filterValues);
                    const values = filterValuesCopy.pop()?.values;
                    const value = values?.pop();

                    return value === "hide";
                }

                return false;
            },
            set(newValue: boolean) {
                // we cannot use booleans as the cloning that take places when updating filters does not handle them nicely
                const value = newValue ? "hide" : "show";
                this.$store.dispatch(MasterTemplateLibraryAction.UpdateResizedFilter, {
                    values: [value]
                });
            }
        }
    },

    beforeUnmount() {
        this.hideResized = false;
    }
});
</script>

<style lang="scss">
.editable-group {
    .show-form--showing {
        display: none;
    }
}

.editable-group__add {
    width: 100%;
}

.editable-group__values {
    width: 100%;
}
</style>
